/** https://developer.mozilla.org/en-US/docs/Web/API/Pointer_Lock_API
 * https://github.com/mrdoob/three.js/blob/master/examples/misc_controls_pointerlock.html
 */

//TODO: remove listeners(!!!)
 
import * as THREE from 'three';
import { PointerLockControls } from 'three/examples/jsm/controls/PointerLockControls.js';

export default class PointerLockManager 
{
    constructor(scene, camera)
    {
        this.scene = scene;
        this.camera = camera;
        this.controls = new PointerLockControls(this.camera, document.body);

        this.setup();
    }

    setup()
    {
        this.moveForward = false;
		this.moveBackward = false;
		this.moveLeft = false;
		this.moveRight = false;
        
        this.velocity = new THREE.Vector3();
        this.direction = new THREE.Vector3();
        this.delta = 0.02; //continuons time, maybe change with clock()

        let blocker = document.getElementById('blocker');
        let instructions = document.getElementById('instructions');
        if(instructions)
        {
            instructions.addEventListener('click', () => 
            {
                // console.log('clicked');
                this.controls.lock();
            }, 
            false);
        };

        this.controls.addEventListener('lock', () =>
        {
            // console.log('lock');
            instructions.style.display = 'none';
            blocker.style.display = 'none';
        } );

        this.controls.addEventListener('unlock', () => 
        {
            // console.log('unlock');
            blocker.style.display = 'block';
            instructions.style.display = '';
        } );

        this.scene.add(this.controls.getObject());

        // console.log('object: ', this.getObject());
        // console.log('controls: ', this.controls);
    }

    update() 
    {
        if (this.controls.isLocked === true)
        {
			this.velocity.x -= this.velocity.x * 10.0 * this.delta;
            this.velocity.z -= this.velocity.z * 10.0 * this.delta;
            this.velocity.y -= 9.8 * 100.0 * this.delta; // 100.0 = mass

            this.direction.z = Number(this.moveForward ) - Number(this.moveBackward );
			this.direction.x = Number(this.moveRight ) - Number(this.moveLeft );
			this.direction.normalize(); // this ensures consistent movements in all directions

			if(this.moveForward || this.moveBackward) this.velocity.z -= this.direction.z * 400.0 * this.delta;
            if(this.moveLeft || this.moveRight) this.velocity.x -= this.direction.x * 400.0 * this.delta;
            
            this.controls.moveRight(- this.velocity.x * this.delta);
			this.controls.moveForward(- this.velocity.z * this.delta);

			this.controls.getObject().position.y += (this.velocity.y * this.delta); // new behavior

            if (this.controls.getObject().position.y < 10) 
            {
                this.velocity.y = 0;
				this.controls.getObject().position.y = 10;
			}
		}
	}

    onKeyDown(e) 
    {
        switch (e.keyCode) 
        {
            case 38: // up
            case 87: // w
                this.moveForward = true;
                // console.log(e.keyCode);
                break;

            case 37: // left
            case 65: // a
                this.moveLeft = true;
                break;

            case 40: // down
            case 83: // s
                this.moveBackward = true;
                break;

            case 39: // right
            case 68: // d
                this.moveRight = true;
                break;
            default: console.log("use up-down-left-right arrows");    
        }
    };

    onKeyUp(e) 
    {
        switch(e.keyCode) 
        {
            case 38: // up
            case 87: // w
                this.moveForward = false;
                break;

            case 37: // left
            case 65: // a
                this.moveLeft = false;
                break;

            case 40: // down
            case 83: // s
                this.moveBackward = false;
                break;

            case 39: // right
            case 68: // d
                this.moveRight = false;
                break;
            default: console.log("use up-down-left-right arrows");   
        }
    };

    getObject() 
    {
        // console.log('getObject: ', this.controls.getObject());
        return this.controls.getObject();
        
    };
    
    getDirection()
    {
        return this.controls.getDirection();
    };

    dispose()
    {
        this.controls.dispose();

    }
}